import { ToggleGroup, ToggleGroupItem } from 'src/components/ui/toggle-group';
import { Control, Controller } from 'react-hook-form';
import { clsx } from 'clsx';
import type { ZendeskHelpCenterFormValues } from 'src/pages/AIKnowledgeBasePage/CurrentKnowledgeBasePage/create/CreateZendeskIntegrationPopup/ZendeskIntegrationForm2/zendeskHelpCenterFormValues';

const ITEM_CLASS_NAME =
  'flex h-9 flex-1 items-center justify-center rounded-lg border-transparent bg-transparent py-0 normal-case hover:border-grey_300 [&[data-state=on]]:border-green_750 [&[data-state=on]]:bg-white [&[data-state=on]]:font-bold';

export const ZendeskHelpCenterIsPrivate = ({
  control,
}: {
  control: Control<ZendeskHelpCenterFormValues>;
}) => {
  return (
    <div className={'flex flex-col gap-2.5'}>
      <div>
        <Controller
          control={control}
          name="is_private"
          render={({ field: { onChange, value }, fieldState: { error } }) => (
            <ToggleGroup
              type="single"
              className={clsx('flex w-full items-stretch gap-2 rounded-lg bg-light p-1')}
              onValueChange={onChange}
              defaultValue={value}
              value={value}
            >
              <ToggleGroupItem className={ITEM_CLASS_NAME} value={'public'}>
                Public Articles Only
              </ToggleGroupItem>
              <ToggleGroupItem className={ITEM_CLASS_NAME} value={'private'}>
                Public & Private Articles
              </ToggleGroupItem>
            </ToggleGroup>
          )}
        />
      </div>
    </div>
  );
};
